
import React from 'react'
import BerhamporeLodge from "../images/berhamporelodgebest.jpg";
import Berhamporehotel from "../images/BERHAMPORELODGEBOOKING.jpg";
import HotelPinewood from "../images/hotelpinewood.jpg";
import HotelPinewoodroom from "../images/hotelpinewoodrooms.jpg";
import { Link } from 'react-router-dom'

function Slider() {
  return (
    <div>
      <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>

  </div>
  
  <div className="carousel-inner">
    <div className="carousel-item active">
      <div className='lodgeberhapore'>
      <img src={BerhamporeLodge} className="d-block w-100" alt="Berhampore Lodge"/>
      </div>
    </div>
    <div className="carousel-item">
    <div className='lodgeberhapore'>
      <img src={Berhamporehotel} className="d-block w-100" alt="best hotel in berhampore"/>
      </div>
    </div>
    <div className="carousel-item">
      <Link to="/Hotelpinewood">
      <div className='lodgeberhapore'>
      <img src={HotelPinewood} className="d-block w-100" alt="Hotel Berhampore Lodge"/>
     
      
      </div>
      </Link>
    </div>
      <div className="carousel-item">
        <a href="tel: +91 8967013299">
      <img src={HotelPinewoodroom} className="d-block w-100" alt="Hotel Pinewood"/></a>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider
